<div class="header" [ngClass]="layout.navColor.colorBg"></div>
<ng-content select="[menu]"></ng-content>
<div class="header" [ngClass]="layout.navColor.colorBg"></div>
<app-message-container></app-message-container>
<div class="content-wrapper">
  <section class="content container-fluid p-3">
    <router-outlet></router-outlet>
  </section>
</div>
<app-navbar-processo></app-navbar-processo>